import type { Sticker } from '../types';

export const essentials: Sticker[] = [
  {
    id: 21001,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/001-calculator.png',
    name: 'Kalkulator',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21002,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/002-approved.png',
    name: 'Zatwierdzono',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21003,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/003-cd rom.png',
    name: 'Płyta CD',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21004,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/004-briefcase.png',
    name: 'Teczka',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21005,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/005-calendar.png',
    name: 'Kalendarz',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21006,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/006-cloud.png',
    name: 'Chmura',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21007,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/007-compass.png',
    name: 'Kompas',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21008,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/008-adjustment.png',
    name: 'Ustawienia',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21009,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/009-diamond.png',
    name: 'Diament',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21010,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/010-database.png',
    name: 'Baza Danych',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21011,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/011-study.png',
    name: 'Nauka',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21012,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/012-diploma.png',
    name: 'Dyplom',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21013,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/013-clock.png',
    name: 'Zegar',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21014,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/014-attachment.png',
    name: 'Załącznik',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21015,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/015-battery.png',
    name: 'Bateria',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21016,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/016-bell.png',
    name: 'Dzwonek',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21017,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/017-letter.png',
    name: 'List',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21018,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/018-low battery.png',
    name: 'Słaba Bateria',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21019,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/019-binoculars.png',
    name: 'Lornetka',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 21020,
    url: 'https://stickers.nauczniaczek.pl/colections/14511015-essentials/png/020-book.png',
    name: 'Książka',
    category: 'essentials',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];